import { useQuery } from 'react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type { SearchData } from '../common';
import {
  getUseSearchQuoteItemsQueryKey,
  UseSearchQuoteItemsQueryKey,
} from './keys';
import type { UseSearchQuoteItemsParams } from './types';

export const useSearchQuoteItems: QueryFunction<
  SearchData,
  [body: UseSearchQuoteItemsParams],
  UseSearchQuoteItemsQueryKey
> = (body, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useQuery({
    ...queryOptions,
    queryKey: getUseSearchQuoteItemsQueryKey(body),
    queryFn: ({ signal }) =>
      request('/search/quote_items', {
        init: {
          signal,
          method: 'POST',
          body: { ...body },
        },
      }),
  });
};
